(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    (() => {
  const mobile = window.matchMedia('(max-width: 989px)');
  const reposition = () => {
    document.querySelectorAll('.lb-reading-layout').forEach((layout) => {
      const aside = layout.querySelector('.lb-reading-aside');
      const content = layout.querySelector('.blog-post-content > rte-formatter');
      if (!aside || !content) return;
      if (mobile.matches) {
        const heading = content.querySelectorAll('h2')[1];
        if (heading) {
          if (heading.previousElementSibling !== aside) heading.before(aside);
        } else if (content.lastElementChild !== aside) {
          content.append(aside);
        }
      } else if (aside.parentElement !== layout) {
        layout.append(aside);
      }
    });
  };
  mobile.addEventListener('change', reposition);
  document.addEventListener('shopify:section:load', reposition);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reposition, { once: true });
  } else {
    reposition();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
